module.exports = __webpack_public_path__ + "img/milmir.eb2c843d.jpg";